import * as THREE from 'three';
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
export class CanvasModel {
    camera!: THREE.PerspectiveCamera;
    scene!: THREE.Scene;
    renderer!: THREE.WebGLRenderer;
    texture!: THREE.DataTexture;
    mesh!: THREE.Mesh;
    raycaster!: THREE.Raycaster;
    controls!: OrbitControls;
}